export enum LoginType {
  SUPERUSER_GOOGLE = 'superuser-google',
  SSO = 'sso',
  USER = 'user',
}
